import React from 'react';
import { useTranslation } from 'react-i18next';

import { MdClear } from 'react-icons/md';
import { AiOutlineCheckCircle, AiOutlineCloudUpload } from 'react-icons/ai';

function Dropzone({ fileList, onFilesSelected }) {
    const [files, setFiles] = React.useState(fileList ? fileList : []);

    const { t } = useTranslation();

    React.useEffect(() => {
        setFiles(fileList)
    }, [fileList]);

    const handleFileChange = (event) => {
        const selectedFiles = event.target.files;
        if (selectedFiles && selectedFiles.length > 0) {
            const newFiles = Array.from(selectedFiles);
            setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) {
            const newFiles = Array.from(droppedFiles);
            setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        }
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    React.useEffect(() => {
        onFilesSelected(files);
    }, [files, onFilesSelected]);

    return (
        <section className='drag-drop'>
            <div
                className={`document-uploader ${files.length > 0 ? 'upload-box active' : 'upload-box'
                    }`}
                onDrop={handleDrop}
                onDragOver={(event) => event.preventDefault()}
            >
                <>
                    <label htmlFor='browse' className='browse-btn'>
                        <div className='upload-info'>
                            <AiOutlineCloudUpload />
                            <div>
                                <p>{t('documents.modals.upload.title')}</p>
                                <p>{t('documents.modals.upload.description')}</p>
                            </div>
                        </div>
                        <div>
                            <input
                                type='file'
                                hidden
                                id='browse'
                                onChange={handleFileChange}
                                accept='.pdf'
                                multiple
                            />
                            <b>{t('documents.modals.upload.buttons.browse')}</b>
                        </div>
                    </label>
                </>

                {files.length > 0 && (
                    <div className='file-list'>
                        <div className='file-list__container'>
                            {files.map((file, index) => (
                                <div className='file-item' key={index}>
                                    <div className='file-info'>
                                        <p>{file.name}</p>
                                    </div>
                                    <div className='file-actions'>
                                        <MdClear onClick={() => handleRemoveFile(index)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {files.length > 0 && (
                    <div className='success-file'>
                        <AiOutlineCheckCircle
                            style={{ color: '#6DC24B', marginRight: 4 }}
                        />
                        {files.length === 1 && <p>{files.length} {t('documents.modals.upload.oneSelected')}</p>}
                        {files.length === 2 && <p>{files.length} {t('documents.modals.upload.twoSelected')}</p>}
                        {files.length === 3 && <p>{files.length} {t('documents.modals.upload.threeSelected')}</p>}
                        {files.length === 4 && <p>{files.length} {t('documents.modals.upload.fourSelected')}</p>}
                        {files.length > 5 && <p>{files.length} {t('documents.modals.upload.moreSelected')}</p>}
                    </div>
                )}
            </div>
        </section>
    );
}

export default Dropzone;